var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectContainer",on:{"click":_vm.emitSelected}},[_c('div',{staticClass:"bkgImage",style:({ 'background-image': 'url(' + require(`/src/assets/film/${_vm.project.thumbnail}`) + ')'})},[_c('div',{staticClass:"projectTitle"},[_vm._v(_vm._s(_vm.project.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }